// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1fpl3","obliqueLineWrap":"membershipbadge_obliqueLineWrap__17LGC","obliqueLine":"membershipbadge_obliqueLine__3yPBp"};